import request from '@/utils/request'

export function listLog(params) {
  return request({
    url: '/config-service/v1/system-log/',
    method: 'get',
    params: params
  })
}

export function listDepartment() {
  return request({
    url: '/config-service/v1/system-log/mObject',
    method: 'get'
  })
}

export function listLogAction() {
  return request({
    url: '/config-service/v1/system-log/mObjectActions',
    method: 'get'
  })
}
